import { render, staticRenderFns } from "./DepartmentsViewsSelector.vue?vue&type=template&id=07f576a5&scoped=true"
import script from "./DepartmentsViewsSelector.vue?vue&type=script&setup=true&lang=js"
export * from "./DepartmentsViewsSelector.vue?vue&type=script&setup=true&lang=js"
import style0 from "./DepartmentsViewsSelector.vue?vue&type=style&index=0&id=07f576a5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07f576a5",
  null
  
)

export default component.exports